import { makeAutoObservable } from 'mobx';
import {endpoints, types} from 'main/tools';
import {DomainStore} from 'shared/store';
import CompanyEmailTemplate from 'main/stores/company_email_templates/CompanyEmailTemplate';
import _ from 'lodash';

class CompanyEmailTemplatesState {
  store = new DomainStore();

  emailTemplates;

  constructor() {
    makeAutoObservable(this, {
      store: false
    });
  }

  async load() {
    await this.store._compose([
      endpoints.COMPANY_EMAIL_TEMPLATES
    ]);

    this.emailTemplates = _.orderBy(
      this.store._getAll(types.COMPANY_EMAIL_TEMPLATE, CompanyEmailTemplate), 'emailType'
    );
  }
}

export default CompanyEmailTemplatesState;
